import { AutoMap } from "@automapper/classes"

export class ELIMSProductDTO {
    @AutoMap()
    eurodat5Code!: string
    @AutoMap()
    productDescription!: string
    @AutoMap()
    partnerCode!: string
    @AutoMap()
    partnerName!: string
}